/*
  Сегменты полосы портфеля — один перечень на два экрана.

  Вынесено 29.09.2026, когда полоса появилась и на «Отчётах», во вкладке
  «Полоски». До этого перечень жил в `DashboardPage`, и второй его экземпляр
  означал бы вторую истину о том, куда ведёт «взыскивать имеет смысл»: адреса
  отбора реестра разошлись бы при первой правке, и одна и та же полоса на двух
  экранах вела бы в разные места.

  🔴 Полоса НЕ считает ничего своего: это те же величины, что в плашках
  дашборда, показанные в масштабе. Порядок - от самого крупного к частным
  случаям, тот же, в каком идут плашки.
*/

export function portfolioSegments(data) {
  return [
    {
      title: 'Взыскивать имеет смысл',
      tone: 'court',
      to: '/registry?route=court',
      ...data.collectable,
    },
    {
      title: 'Только исковое',
      tone: 'lawsuit',
      to: '/registry?route=lawsuit',
      ...data.lawsuit,
    },
    {
      title: 'Невыгодно судиться',
      tone: 'pretrial',
      to: '/registry?route=pretrial_batch',
      ...data.unprofitable,
    },
    {
      title: 'Исключены из взыскания',
      tone: 'excluded',
      to: '/registry?route=excluded',
      ...data.excluded,
    },
    {
      title: 'Нужен человек',
      tone: 'manual',
      to: '/registry?route=manual_review',
      ...data.needs_human,
    },
  ]
}

/*
  Сегменты полосы сроков. Здесь адреса отбора реестра те же, что у значка
  «горит» в меню и у тревоги на дашборде: полоса давности - ось реестра с
  первого дня, и заводить под неё что-то своё не понадобилось.

  Полоса «срок истёк» в перечне есть, хотя цена требования у неё нулевая по
  определению: пустой сегмент полоса не рисует сама, а вычёркивать его здесь
  значило бы спрятать существующее состояние счёта.
*/
export function limitationSegments(limitation) {
  const titles = {
    within: 'В пределах срока',
    expiring_soon: 'Горит срок давности',
    expired: 'Срок истёк',
  }
  const tones = { within: 'court', expiring_soon: 'burn', expired: 'excluded' }
  return limitation.map((segment) => ({
    title: titles[segment.band],
    tone: tones[segment.band],
    to: `/registry?limitation=${segment.band}`,
    amount: segment.amount,
    accounts: segment.accounts,
  }))
}
